import { render, staticRenderFns } from "./TreeReportsReviewDirect.vue?vue&type=template&id=2e2e01f0&"
import script from "./TreeReportsReviewDirect.vue?vue&type=script&lang=js&"
export * from "./TreeReportsReviewDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports